import { Globe, Coins } from "lucide-react";
import { useTimezone, tzAbbr, COMMON_TIMEZONES } from "@/lib/time";
import { useOddsFormat, ODDS_FORMATS } from "@/lib/odds";

const selectCls = "min-h-[40px] rounded-md border border-[#2A364F] bg-[#0A0D14] px-2 py-1 font-mono text-base text-slate-300 outline-none focus:border-[#00E676] sm:min-h-0 sm:text-[11px]";

export function TimezoneBar({ compact = false }) {
  const { tz, setTz, isManual, detected } = useTimezone();
  const { format, setFormat } = useOddsFormat();
  const options = COMMON_TIMEZONES.includes(detected) ? COMMON_TIMEZONES : [detected, ...COMMON_TIMEZONES];
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-2 ${compact ? "" : "rounded-lg border border-[#1E2738] bg-[#0F131D] px-3 py-2"}`} data-testid="timezone-bar">
      <div className="flex flex-wrap items-center gap-2">
        <Globe size={13} className="text-[#00E676]" />
        <span className="font-mono text-[11px] uppercase tracking-wider text-slate-400" data-testid="timezone-label">
          Times in {isManual ? "" : "your local zone · "}<span className="text-white">{tz.replace(/_/g, " ")} ({tzAbbr(tz)})</span>
        </span>
        <select data-testid="timezone-select" value={tz} onChange={(e) => setTz(e.target.value === detected ? "" : e.target.value)} className={selectCls}>
          {options.map((z) => <option key={z} value={z}>{z.replace(/_/g, " ")}{z === detected ? " (detected)" : ""}</option>)}
        </select>
      </div>
      <div className="flex items-center gap-2 sm:ml-auto">
        <Coins size={13} className="text-[#00E676]" />
        <span className="font-mono text-[11px] uppercase tracking-wider text-slate-400">Odds</span>
        <select data-testid="odds-format-select" value={format} onChange={(e) => setFormat(e.target.value)} className={selectCls}>
          {ODDS_FORMATS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </div>
    </div>
  );
}
